var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoAccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M594.444 283.331C594.444 263.427 586.849 243.523 571.663 228.336C556.477 213.149 536.57 205.556 516.667 205.556M516.667 516.667C645.533 516.667 750 412.199 750 283.333C750 154.467 645.533 50 516.667 50C387.801 50 283.333 154.467 283.333 283.333C283.333 293.976 284.046 304.453 285.426 314.718C287.696 331.602 288.831 340.045 288.067 345.384C287.271 350.949 286.258 353.944 283.516 358.852C280.883 363.561 276.244 368.201 266.966 377.479L68.2245 576.221C61.4987 582.945 58.1356 586.309 55.7307 590.233C53.5984 593.713 52.0273 597.505 51.0745 601.476C50 605.952 50 610.708 50 620.216V687.778C50 709.559 50 720.448 54.2385 728.767C57.9672 736.086 63.9164 742.032 71.2337 745.761C79.5524 750 90.4425 750 112.222 750H205.556V672.222H283.333V594.444H361.111L422.521 533.035C431.799 523.756 436.439 519.117 441.148 516.484C446.056 513.742 449.051 512.727 454.616 511.934C459.955 511.168 468.398 512.303 485.283 514.574C495.546 515.955 506.023 516.667 516.667 516.667Z",
    stroke: "white",
    strokeWidth: 66.6667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAccess);
export default __webpack_public_path__ + "static/media/ico_access.dbbd0fa133089a7570ecf597a36559d4.svg";
export { ForwardRef as ReactComponent };